<template>
  <div>
    <div class="customer">
      <div class="customer-title">
        <h3>货主信息</h3>
        <span>切换货主名称，查看具体货品补货信息</span>
      </div>
      <div
        v-for="(item, index) in customerList"
        :key="item.customerCode"
        :class="['customer-item', {'active-customer': activeIndex === index}]"
        @click="changeCustomer(index)"
      >
        {{item.customerName}}
      </div>
    </div>
    <block-title
      title="货品补货信息"
      :show-line="false"
      class="table-block"
    >
      <div slot="icon-right" class="block-icon-right">
        <a-button @click="getInit(true)">
          <img src="@/assets/img/icon/icon_update.png" alt="">
          {{updateText}}
        </a-button>
      </div>
      <div class="search-table">
        <div class="flex justify-between">
          <a-input-search
            v-model="searchValue"
            placeholder="请输入货品编码/名称、仓库名称查询"
            style="width: 360px"
            @search="onSearch"
          />
          <p>上次更新时间：{{updateTime}}</p>
        </div>
        <a-table
          class="good-table"
          :columns="tableColumns"
          :data-source="dataSource"
          row-key="id"
          :pagination="false"
          :scroll="{y: 392 }"
        >
          <template slot="goodsName" slot-scope="text, rowData">
            <a-tooltip placement="topLeft" :title="text">
              <a @click="replenishmentDetail(rowData)">{{text}}</a>
            </a-tooltip>
          </template>
          <template slot="amount" slot-scope="text">
            <span class="amount">{{text}}</span>
          </template>
          <template slot="action" slot-scope="text, rowData">
            <a @click="replenishmentRecord(rowData)">补货记录</a>
          </template>
        </a-table>
        <a-button
          type="primary"
          class="replenishment-btn"
          @click="toIframe"
        >前往补货</a-button>
      </div>
    </block-title>
    <replenishment-record ref="replenishmentRecord" />
    <replenishment-detail ref="replenishmentDetail" />
  </div>
</template>

<script>
import BlockTitle from '@/components/panel/BlockTitle.vue'
import moment from 'moment'
import { mapMutations } from 'vuex'
import { setAppToken } from '@/utils/auth'
import ReplenishmentRecord from './Record.vue'
import ReplenishmentDetail from './Detail.vue'
import { tableColumns } from '../const'
import { getReplenishmentCustomer, getReplenishmentList } from '../../api'

export default {
  name: 'ReplenishmentInfo',
  components: {
    BlockTitle,
    ReplenishmentRecord,
    ReplenishmentDetail,
  },
  props: {
    index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: 0,
      tableColumns,
      dataSource: [],
      searchValue: '',
      customerList: [],
      isUpdate: false,
      updateText: '更新补货信息',
      isIframe: false,
    }
  },
  computed: {
    // updateTime() {
    //   return this.dataSource?[0]?.updateTime
    // }
    updateTime(){
      return this.dataSource.length ? moment(this.dataSource[0].updateTime).format('YYYY-MM-DD HH:mm:ss') : ''
    }
  },
  created() {
    // 如果是嵌入的页面，需要取apptoken
    if (this.$route.path === '/application/replenishment') {
      const {appToken} = this.$route.query
      this.isIframe = true
      if (appToken) {
        setAppToken(appToken)
      }
    }
    this.getInit()
  },
  methods: {
    ...mapMutations('setting', ['setCount']),
    replenishmentRecord(row) {
      const record = row
      const { customerCode } = record
      const current = this.customerList.filter(item => item.customerCode === customerCode)[0] || {}
      record.customerName = current.customerName
      this.$refs.replenishmentRecord.show(record)
    },
    replenishmentDetail(record) {
      this.$refs.replenishmentDetail.show(record)
    },
    onSearch() {
      this.getList()
    },
    async getInit(isUpdate = false) {
      if (isUpdate) {
        this.updateText = '更新中'
      }
      this.searchValue = ''
      const param = {}
      if(this.isIframe) {
        const {customerCode, customerName} = this.$route.query
        param.customerCode = customerCode
        param.customerName = customerName
      }
      const res = await getReplenishmentCustomer(param)
      this.customerList = res
      this.setCount(res.length)
      if (res.length) {
        this.getList(isUpdate)
      } else if (isUpdate) {
        this.updateText = '更新补货信息'
        this.$message.success('补货信息已更新')
      }
    },
    async getList(isUpdate = false) {
      const { customerList, activeIndex, searchValue } = this
      const code = customerList[activeIndex].customerCode
      const res = await getReplenishmentList({
        customerCodes: [code],
        keyword: searchValue,
      })
      this.dataSource = res
      if (isUpdate) {
        this.updateText = '更新补货信息'
        this.$message.success('补货信息已更新')
      }
    },
    changeCustomer(index) {
      this.activeIndex = index
      this.searchValue = ''
      this.getList()
    },
    toIframe() {
      const {index, customerList, activeIndex} = this
      if (customerList.length) {
        this.$emit('changeType', index, customerList[activeIndex].customerCode)
      } else {
        this.$message.error('未选择货主')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.customer {
  .customer-title {
    color: #909399;
    h3 {
      color: #171717;
      font-size: 18px;
      display: inline-block;
      margin-right: 12px;
    }
  }
  .customer-item {
    display: inline-block;
    height: 40px;
    line-height: 40px;
    padding: 0 16px;
    background: #DCDEE0;
    border-radius: 4px;
    margin-right: 20px;
    margin-top: 16px;
    cursor: pointer;
    &.active-customer {
      background: linear-gradient(244deg, #06B889 0%, #24D69E 100%);
      color: #fff;
      position: relative;
      &::after {
        content: '';
        width: 0px;
				height: 0px;
				border-top: 6px solid #24D69E;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        position: absolute;
        top: 100%;
        left: 50%;
        transform: translateX(-50%)
      }
    }
  }
}
.table-block {
  margin-top: 24px;
  background: #fff;
  border-radius: 6px;
  padding: 24px 24px 24px 0;
  .block-icon-right {
    flex: 1;
    text-align: right;
    /deep/ .ant-btn {
      border: 1px solid #06B880;
      color: #06B880;
      &:hover {
        border: 1px solid #009168;
        color: #009168;
      }
    }
    img {
      width: 20px;
      margin-right: 8px;
    }
  }
  .update-time {
    color: #909399;
    text-align: right;
  }
  .search-table {
    padding-left: 24px;
  }
  .good-table {
    margin-top: 24px;
    border-radius: 6px;
    border: 1px solid #f0f0f0;
    /deep/ .ant-table-body {
      // overflow-y: auto !important;
    }
    .amount {
      color: #ED4934;
    }
  }
  .replenishment-btn {
    margin-top: 30px;
  }
}
</style>
